document.querySelectorAll(".js-readmore").forEach((textEl) => {
    const themes = Array.from(textEl.children)
        .map((theme) => theme.textContent.trim())
        .filter(Boolean);
    const fullText = themes.join(" ");
    const limit = 300;
    const btn = textEl.nextElementSibling;

    if (btn && fullText.length > limit) {
        btn.classList.remove("hidden");
        const shortThemes = [];
        let remaining = limit;

        for (const theme of themes) {
            const separatorLength = shortThemes.length ? 1 : 0;
            const visibleLength = Math.min(theme.length, remaining - separatorLength);

            if (visibleLength <= 0) {
                break;
            }

            shortThemes.push(theme.slice(0, visibleLength));
            remaining -= visibleLength + separatorLength;

            if (visibleLength < theme.length) {
                break;
            }
        }

        shortThemes[shortThemes.length - 1] += "…";

        const renderThemes = (displayedThemes) => {
            textEl.replaceChildren(
                ...displayedThemes.map((theme) => {
                    const item = document.createElement("li");
                    item.textContent = theme;

                    return item;
                }),
            );
        };

        renderThemes(shortThemes);
        btn.style.display = "inline-block";

        let expanded = false;
        btn.addEventListener("click", () => {
            if (!expanded) {
                renderThemes(themes);
                btn.textContent = "閉じる";
                expanded = true;
            } else {
                renderThemes(shortThemes);
                btn.textContent = "もっと見る";
                expanded = false;
            }
        });
    }
});

const boxSearch = document.getElementById("jsSearchBox");
const searchConditions = document.getElementById("searchConditions");
const searchFooter = document.getElementById('searchFooter');
let isAppend = false;

window.addEventListener('scroll', () => {
    if (!searchFooter || !boxSearch) return;
    const hasBoxSearch = searchFooter.querySelector("#jsSearchBox");
    const targetPoint = document.documentElement.scrollHeight - window.innerHeight - boxSearch?.offsetHeight - document.getElementById('header').offsetHeight;
    if (isAppend) return;
    if(window.pageYOffset > targetPoint) {
        if (!hasBoxSearch) {
            boxSearch.remove();
            searchFooter.appendChild(boxSearch);
            searchConditions.style.height = "0";
            isAppend = true;
        }
    }
});

document.addEventListener("click", function (e) {
    if (e.target.closest(".jsRemoveResult")) {
        e.preventDefault();
        const tr = e.target.closest("tr");
        if (tr) {
            tr.remove();
        }
    } else if (e.target.closest(".jsChangeOtpSearch")) {
        e.preventDefault();
        isAppend = false;
        boxSearch.remove();
        searchConditions.appendChild(boxSearch);
        const fullHeight = boxSearch.scrollHeight + "px";
        if (searchConditions.offsetHeight === 0) {
            searchConditions.style.height = fullHeight;
        } else {
            searchConditions.style.height = fullHeight;
            requestAnimationFrame(() => {
                searchConditions.style.height = "0";
            });
            boxSearch.remove();
            searchFooter.appendChild(boxSearch);
            isAppend = true;
        }
    }
});

window.addEventListener("resize", () => {
    if (window.innerWidth <= 768) return;
    if (!searchConditions) return;
    if (searchConditions.offsetHeight > 0) {
        searchConditions.style.height = "auto";
        const newHeight = searchConditions.scrollHeight;
        searchConditions.style.height = newHeight + "px";
    }
});

document.querySelectorAll('.jsButtonContactSearch').forEach(link => {
    link.addEventListener('click', () => {
        sessionStorage.setItem('reloadSearch', '1');
    });
});
window.addEventListener('pageshow', () => {
    if (sessionStorage.getItem('reloadSearch') && window.location.href.includes('/search')) {
        sessionStorage.removeItem('reloadSearch');
        location.reload();
    }
});